import { Injectable, Query } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Observable, BehaviorSubject } from 'rxjs';

import { AccountDetails } from '../models/AccountDetail';
import { UserInfoModel } from '../models/UserInfoModel';
import { CustomerContactMethodModel } from '../models/CustomerContactMethodModel';

@Injectable()
export class AccountDetailsService {

  private customerAccountData = new BehaviorSubject(null);

  private static handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      if (error.status === 404) {
        errMsg = `Resource ${error.url} was not found`;
      } else {
        const body = error.json() || '';
        const err = /*body.error ||*/ JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }

  constructor(private http: HttpClient) { }

  //getAccountDetails(): AccountDetails {
  //  return ACCOUNT_DETAILS;
  //}

  getUserInfo(orgUnitId: string, accountId: string): Observable<UserInfoModel> {
    //let _body = JSON.stringify({ username: username, password: password });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('accountId', accountId);

    let response = this.http.get<any>('/Portal/UserInfo', { params });
    return response;
    //.pipe(
    //  catchError(this.handleError('addHero', email))
    //);


   
  //getAccountDetailsx(): Observable<AccountDetails> {
  //  return this.http.get('/fake-backend/employees')
  //    .map(response => response.json() as AccountDetails)
  //    .catch(AccountDetailsService.handleError);
  }

  getUserContactMethods(orgUnitId: string, accountId: string): Observable<CustomerContactMethodModel[]> {

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId)
      .set('accountId', accountId);

    return this.http.get<any>('/Portal/GetUserContactMethod', { params });
  }

  getMeterDates(deviceId: string, isOpenCommand: boolean, date: string): Observable<any> {

    const params = new HttpParams()
      .set('deviceId', deviceId)
      .set("isOpenCommand", isOpenCommand.toString())
      .set("date", date);

    return this.http.get<any>('/Portal/GetMeterDates', { params });
  }



  getOrgConsumptionType(orgUnitId: string): Observable<any> {

    const params = new HttpParams()
      .set('orgUnitId', orgUnitId);

    return this.http.get<any>('/Portal/GetOrgConsumptionType', { params });
  }


  getPendingCommands(deviceId: string) {
    const params = new HttpParams()
      .set('deviceId', deviceId);

    return this.http.get<any>('/Portal/GetPendingCommands', { params });
  }

  updateUserContactMethods(CustomerMethodsModel: any): Observable<any> {

    let _body = JSON.stringify(CustomerMethodsModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.put<any>('/Portal/UpdateUserContactMethod', _body, httpOptions);
  }

  UpsertAccountBudget(accountid: number, budget: number): Observable<any> {
    return this.http.post<any>(`/Portal/CustomerAccountBudget?accountid=${accountid}&budget=${budget}`, null);
  }

  DeleteUserContactMethods(orgunitid: number, accountid: number, id: number): Observable<boolean> {
    return this.http.delete<any>(`/Portal/DeleteUserContactMethod?orgunitid=${orgunitid}&id=${id}&accountid=${accountid}`);
  }


  AddUserContactMethods(CustomerMethodsModel: any): Observable<boolean> {

    let _body = JSON.stringify(CustomerMethodsModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/PostUserContactMethod', _body, httpOptions);
  }

  cancelCommand(CustomerCommandCancelModel: any): Observable<any> {

    let _body = JSON.stringify(CustomerCommandCancelModel);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/CancelCommand', _body, httpOptions);
  }

  submitDisconnetInfo(CustomerValveTurnModel: any): Observable<any> {
    let _body = JSON.stringify(CustomerValveTurnModel); 
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.post<any>('/Portal/SubmitDisconnectInfo', _body, httpOptions);
  }

  reportOutage(CustomerMethodsModel: any): Observable<any> {
    let _body = JSON.stringify(CustomerMethodsModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
    return this.http.post<any>('/Portal/ReportOutage', _body, httpOptions);
  }

  sendSupportMessage(SupportMessageModel: any): Observable<any> {
    let _body = JSON.stringify(SupportMessageModel);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
    return this.http.post<any>('/Portal/SendSupportMessage', _body, httpOptions);
  }


  getCustomerAccountData() {
    return this.customerAccountData.asObservable();
  }

  setCustomerAccountData(userInfo: UserInfoModel) {
    return this.customerAccountData.next(userInfo);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/account-details.service.ts